{
  "help": "帮助",
  "info": "信息"
}
